import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class CryptService {

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, environment.data.secretKey.trim()).toString();
  }

  decrypt(textToDecrypt: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, environment.data.secretKey.trim()).toString(CryptoJS.enc.Utf8);
  }
}
